import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/esm/Table';
import { CGM_CODE_SET, Channel_CODE_SET, Section_CODE_SET } from '../../../config/CgmCodeSet';
import PaginationAnything from '../pagination/PaginationAnything';

import './TableForReport.css'

const openInNewTab = (url) => {
  var win = window.open(url, "", '_blank');
  win.focus();
}

const arrayCompare = (arr1, arr2) => {
  for (let i = 0; i < arr1.length || i < arr2.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
    else {
      continue;
    }
  }
  return true;
}

const BuzzlistTable = (props) => {
  const data = props.data.buzzlist;
  const channel = Channel_CODE_SET[props.data.info.code];
  const tableBodyRowSize = parseInt(props.options.buzzRows);
  const pageLength = Math.ceil(data.length / tableBodyRowSize);
  const tablePageWindowSize = props.pageSize;

  const [activePage, setActivePage] = useState(1);
  let currentTableRow = (activePage - 1) * tableBodyRowSize;

  const handleActivePage = (index) => {
    setActivePage(index);
  }

  return (
    <>
      <Table responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>Channel</th>
            <th>Published</th>
          </tr>
        </thead>
        <tbody>
          {(data.filter((item, index) => (index >= currentTableRow) && (index < (currentTableRow + tableBodyRowSize)))).map((row, rowIndex) => {
            return (
              <tr>
                <td>{(activePage - 1) * tableBodyRowSize + rowIndex + 1}</td>
                <td>
                  <span style={{ cursor: "pointer" }} onClick={() => openInNewTab(row.title_link)}>
                    {row.title}
                  </span>
                </td>
                {/* <td>{CGM_CODE_SET[row.cgm]}</td> */}
                {/* <td>{Section_CODE_SET[row.sectioncode]}</td> */}
                <td>
                  {/* {channel} */}
                  {row.channel}
                </td>
                <td>{row.published}</td>
              </tr>
            )
          })}
        </tbody>
      </Table>
      <div style={{ textAlign: 'center' }} >
        <PaginationAnything windowSize={tablePageWindowSize} handleActivePage={handleActivePage} pageLength={pageLength} activePage={activePage} />
      </div>
    </>
  )
}

const RelationTable = (props) => {
  const [onText, setOnText] = useState('');

  let rows = [];
  for (let i = 0; i < props.options.words; i++) {
    rows.push(
      <tr>
        <th>{i + 1}</th>
        {props.data.data.map(item => {
          if (item.data.length > i) {
            return (
              <th className={onText == item.data[i].text ? 'hover-cell' : null} onMouseEnter={(e) => {
                if (e.target.childNodes[0].innerText != undefined) {
                  setOnText(e.target.childNodes[0].innerText)
                }
              }}
                onMouseLeave={() => setOnText('')}
              >
                <div className="relation-row-text">{item.data[i].text}</div><div className="relation-row-value">{item.data[i].value}</div>
              </th>
            )
          }
          else
            return (
              <th></th>
            )
        })}
      </tr>
      // <tr>
      //   <th>{i+1}</th>
      //   {props.data.data.map(item=>{
      //     if(item.data.length > i){
      //       return(
      //         <>
      //           <th onMouseEnter={(e)=>console.log(e.target.innerText)} onMouseLeave={(e)=>console.log(e)}>
      //             {item.data[i].text}
      //           </th>
      //           <th>
      //             {item.data[i].value}
      //           </th>
      //         </>
      //       )
      //     }
      //     else
      //       return(
      //         <>
      //           <th></th>
      //           <th></th>
      //         </>
      //       )
      //   })}
      // </tr>
    )
  }

  return (
    <>
      <Table responsive bordered>
        <thead>
          <tr>
            <th rowSpan="2">순위</th>
            {props.data.data.map(item => {
              return (
                // <th colSpan="2">{item.date}</th>
                <th>{item.date}</th>
              )
            })}
          </tr>
          <tr>
            {props.data.data.map(item => {
              return (
                <>
                  {/* <th>연관어</th>
                  <th>건수</th> */}
                  <th><div className="relation-row-text">연관어</div><div className="relation-row-value">건수</div></th>
                </>
              )
            })}
          </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </Table>
    </>
  )
}

const PositioningmapTable = (props) => {

  return (
    <>
      <Table responsive>
        <thead>
          <tr>
            <th>채널</th>
            <th>검색어</th>
            <th>PSR</th>
            <th>긍정</th>
            <th>부정</th>
            <th>버즈량</th>
          </tr>
        </thead>
        <tbody>
          {props.data.reportData.map((item, index) => {
            return (
              <>
                {item.data.map(subItem => {
                  return (
                    <tr>
                      <td>{Channel_CODE_SET[item.channel]}</td>
                      <td>{subItem.title}</td>
                      <td>{subItem.positive.value + subItem.negative.value == 0 ? "NaN" : subItem.y}</td>
                      <td>{subItem.positive.value}</td>
                      <td>{subItem.negative.value}</td>
                      <td>{subItem.value}</td>
                    </tr>
                  )
                })}
              </>
            )
          })}
        </tbody>
      </Table>
    </>
  )
}

const CategoryTable = (props) => {
  const data = props.data;

  return (
    <>
      <Table responsive>
        <thead>
          <tr>
            <th>Rank</th>
            <th>{Channel_CODE_SET[data.channel]}</th>
            <th>Sum</th>
            <th>Word</th>
            <th>Count</th>
          </tr>
        </thead>
        <tbody>
          {data.data[0].children.map((categoryItem, categoryIndex) => {
            return (
              <>
                <tr>
                  <td>
                    {categoryIndex + 1}
                  </td>
                  <td>
                    {categoryItem.name}
                  </td>
                  <td>
                    {categoryItem.value}
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                {categoryItem.children.map((categoryChildren) => {
                  return (
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>
                        {categoryChildren.name}
                      </td>
                      <td>
                        {categoryChildren.value}
                      </td>
                    </tr>
                  )
                })}
              </>
            )
          })}
        </tbody>
      </Table>
    </>
  )
}

const SourceTable = (props) => {
  const data = props.data.content;
  const channel = Channel_CODE_SET[props.data.info.channel];
  const tableBodyRowSize = 10;
  const pageLength = Math.ceil(data.length / props.pageSize);
  const tablePageWindowSize = props.pageSize;

  const [activePage, setActivePage] = useState(1);
  let currentTableRow = (activePage - 1) * tableBodyRowSize;

  const handleActivePage = (index) => {
    setActivePage(index);
  }

  return (
    <>
      <Table responsive>
        <thead>
          <tr>
            <th>순위</th>
            <th>채널명</th>
            <th>{channel}</th>
            <th>버즈량</th>
          </tr>
        </thead>
        <tbody>
          {(data.filter((item, index) => (index >= currentTableRow) && (index < (currentTableRow + tableBodyRowSize)))).map((row, rowIndex) => {
            return (
              <tr>
                <td>{(activePage - 1) * 10 + rowIndex + 1}</td>
                <td>
                  <span style={{ cursor: "pointer" }} onClick={() => openInNewTab(row.link)}>
                    {row.title}
                  </span>
                </td>
                {/* <td>{CGM_CODE_SET[row.cgm]}</td> */}
                {/* <td>{Section_CODE_SET[row.sectioncode]}</td> */}
                <td>
                  {Section_CODE_SET.hasOwnProperty(row.sectioncode) ?
                    Section_CODE_SET[row.sectioncode]
                    : channel}
                </td>
                <td>{row.frequency}</td>
              </tr>
            )
          })}
        </tbody>
      </Table>
      <div style={{ textAlign: 'center' }} >
        <PaginationAnything windowSize={tablePageWindowSize} handleActivePage={handleActivePage} pageLength={pageLength} activePage={activePage} />
      </div>
    </>
  )
}

const SentimentTable = (props) => {
  const data = props.data;
  const query = props.query;
  return (
    <Table responsive>
      <thead>
        <tr>
          <th>채널</th>
          <th>날짜</th>
          <th>긍정</th>
          <th>부정</th>
          <th>혼합</th>
          <th>중립</th>
          <th>긍정비율</th>
          <th>부정비율</th>
        </tr>
      </thead>
      <tbody>
        {data.reportData.filter(reportItem => arrayCompare(reportItem.query, query)).map((filteredItem) => {
          return (
            <>
              {filteredItem.data.map((row, index) => {
                let sumFreq = row.positive + row.negative + row.mix + row.neutral;
                return (
                  <tr>
                    {index == 0 ?
                      <td rowSpan={filteredItem.data.length}>
                        {Channel_CODE_SET[filteredItem.channel]}
                      </td>
                      : null}
                    <td>
                      {row.hasOwnProperty('end_date') ?
                        `${row.date} ~ ${row.end_date}`
                        : row.date}
                    </td>
                    <td>
                      {row.positive}
                    </td>
                    <td>
                      {row.negative}
                    </td>
                    <td>
                      {row.mix}
                    </td>
                    <td>
                      {row.neutral}
                    </td>
                    <td>
                      {sumFreq == 0 ?
                        'N/A'
                        : `${Math.round((row.positive / sumFreq) * 10000) / 100}%`}
                    </td>
                    <td>
                      {sumFreq == 0 ?
                        'N/A'
                        : `${Math.round((row.negative / sumFreq) * 10000) / 100}%`}
                    </td>
                  </tr>
                )
              })}
            </>
          )
        })}
      </tbody>
    </Table>
  )
}

const VolumeTable = (props) => {
  const data = props.data;
  return (
    <Table responsive>
      <thead>
        <tr>
          <th>검색어</th>
          <th>날짜</th>
          {data.channels.map((channel, index) =>
            <th key={`table-header-${index}`}>
              {Channel_CODE_SET[channel]}
            </th>
          )}
        </tr>
      </thead>
      <tbody>
        {data.reportData.map((reportItem, index) => {
          return (
            <>
              {reportItem.data.map((row, index) => (
                <tr>
                  {index == 0 ?
                    <td rowSpan={reportItem.data.length}>
                      {reportItem.query.join(' & ')}
                    </td>
                    : null}
                  <td>
                    {row.hasOwnProperty('end_date') ?
                      `${row.date} ~ ${row.end_date}`
                      : row.date}
                  </td>
                  {reportItem.channel.map((channel) =>
                    <td>
                      {row[channel]}
                    </td>
                  )}
                </tr>
              ))}
            </>
          )
        })}
      </tbody>
    </Table>
  )
}

const EmotionTable = (props) => {
  const data = props.data;
  const query = props.query;
  return (
    <Table responsive>
      <thead>
        <tr>
          <th>채널</th>
          <th>날짜</th>
          <th>기쁨</th>
          <th>혐오</th>
          <th>공포</th>
          <th>놀람</th>
          <th>분노</th>
          <th>통증</th>
          <th>흥미</th>
          <th>지루</th>
          <th>슬픔</th>
          <th>기타</th>
        </tr>
      </thead>
      <tbody>
        {data.reportData.filter(reportItem => arrayCompare(reportItem.query, query)).map((filteredItem) => {
          return (
            <>
              {filteredItem.data.map((row, index) => {
                let sumFreq = row.pleasure + row.aversion + row.fear + row.surprised + row.anger + row.ache + row.interest + row.boring + row.sadness + row.etc;
                return (
                  <tr>
                    {index == 0 ?
                      <td rowSpan={filteredItem.data.length}>
                        {Channel_CODE_SET[filteredItem.channel]}
                      </td>
                      : null}
                    <td>
                      {row.hasOwnProperty('end_date') ?
                        `${row.date} ~ ${row.end_date}`
                        : row.date}
                    </td>
                    <td>
                      {sumFreq == 0 ?
                        row.pleasure
                        : `${row.pleasure} (${Math.round((row.pleasure / sumFreq) * 10000) / 100}%)`}
                    </td>
                    <td>
                      {sumFreq == 0 ?
                        row.aversion
                        : `${row.aversion} (${Math.round((row.aversion / sumFreq) * 10000) / 100}%)`}
                    </td>
                    <td>
                      {sumFreq == 0 ?
                        row.fear
                        : `${row.fear} (${Math.round((row.fear / sumFreq) * 10000) / 100}%)`}
                    </td>
                    <td>
                      {sumFreq == 0 ?
                        row.surprised
                        : `${row.surprised} (${Math.round((row.surprised / sumFreq) * 10000) / 100}%)`}
                    </td>
                    <td>
                      {sumFreq == 0 ?
                        row.anger
                        : `${row.anger} (${Math.round((row.anger / sumFreq) * 10000) / 100}%)`}
                    </td>
                    <td>
                      {sumFreq == 0 ?
                        row.ache
                        : `${row.ache} (${Math.round((row.ache / sumFreq) * 10000) / 100}%)`}
                    </td>
                    <td>
                      {sumFreq == 0 ?
                        row.interest
                        : `${row.interest} (${Math.round((row.interest / sumFreq) * 10000) / 100}%)`}
                    </td>
                    <td>
                      {sumFreq == 0 ?
                        row.boring
                        : `${row.boring} (${Math.round((row.boring / sumFreq) * 10000) / 100}%)`}
                    </td>
                    <td>
                      {sumFreq == 0 ?
                        row.sadness
                        : `${row.sadness} (${Math.round((row.sadness / sumFreq) * 10000) / 100}%)`}
                    </td>
                    <td>
                      {sumFreq == 0 ?
                        row.etc
                        : `${row.etc} (${Math.round((row.etc / sumFreq) * 10000) / 100}%)`}
                    </td>
                  </tr>
                )
              })}
            </>
          )
        })}
      </tbody>
    </Table>
  )
}

const TableForReport = (props) => {
  switch (props.reportType) {
    case "volume": {
      return (
        <VolumeTable data={props.data} />
      )
    }
    case "sentiment": {
      return (
        <SentimentTable data={props.data} query={props.query} />
      )
    }
    case "source": {
      return (
        <SourceTable data={props.data} pageSize={props.pageSize} />
      )
    }
    case "category": {
      return (
        <CategoryTable data={props.data} />
      )
    }
    case "positioningmap": {
      return (
        <PositioningmapTable data={props.data} />
      )
    }
    case "relation": {
      return (
        <RelationTable data={props.data} options={props.options} />
      )
    }
    case "buzzlist": {
      return (
        <BuzzlistTable data={props.data} options={props.options} pageSize={props.pageSize} />
      )
    }
    case "channel_buzzlist": {
      return (
        <BuzzlistTable data={props.data} options={props.options} pageSize={props.pageSize} />
      )
    }
    case "emotion": {
      return (
        <EmotionTable data={props.data} query={props.query} />
      )
    }
    default:
      return null;
  }
}

export default TableForReport;